import { render, staticRenderFns } from "./OutArgicProduct.vue?vue&type=template&id=32ff6bb7&scoped=true"
import script from "./OutArgicProduct.vue?vue&type=script&lang=js"
export * from "./OutArgicProduct.vue?vue&type=script&lang=js"
import style0 from "./OutArgicProduct.vue?vue&type=style&index=0&id=32ff6bb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff6bb7",
  null
  
)

export default component.exports